// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1QPpT","checkboxCol":"Table_checkboxCol__3_49R","emailCol":"Table_emailCol__10jro","actionCol":"Table_actionCol__33DV8"};